import _sfc_main from "./FlowDropdownItem.vue2.js";
import _export_sfc from "../_virtual/_plugin-vue_export-helper.js";
const FlowDropdownItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-2738cb6f"]]);
export {
  FlowDropdownItem as default
};
//# sourceMappingURL=FlowDropdownItem.vue.js.map
